import { request } from '../handleRequest';

export const buildRequestURL = (carePlanId, type, recurring) => {
  let url = `/care_plan_templates/${carePlanId}/`;

  switch (type) {
    case 'Task':
      url += recurring ? 'repeated_task_templates' : 'task_templates';
      break;
    case 'Appointment':
      url += recurring ? 'repeated_appointment_templates' : 'task_templates'; // task_template path also handles singular appointments
      break;
    default:
      url = '/404';
  }

  return url;
};

export const createActivityTemplateApiWrapper = (
  requestProvider = request,
  buildRequestURLProvider = buildRequestURL
) => {
  return async (carePlanId, activity, type, recurring) => {
    try {
      const body = {
        ...activity,
        type,
      };

      const endpointUrl = buildRequestURLProvider(carePlanId, type, recurring);
      const response = await requestProvider(endpointUrl, 'POST', body);
      const status = response.status;

      let responseBody = {};
      try {
        responseBody = await response.json();
      } catch (e) {
        console.error('Failed to parse response JSON:', e);
      }

      if (!response.ok) {
        return {
          status,
          ...(responseBody || { error: 'Unknown server error' })
        };
      }

      return {
        status,
        ...responseBody
      };

    } catch (error) {
      return {
        status: 500,
        error: error.message || 'Network request failed'
      };
    }
  };
};

export default createActivityTemplateApiWrapper(request, buildRequestURL);
